<!-- Switch Input -->
@if (name) {
  <div class="w-full"
       [class.field]="formField">
    @if (labelTop && label) {
      <label
        id="{{ name }}_label"
        class="flex flex-grow-1"
        [class.mb-2]="!formField"
        for="{{ name }}">
        <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
          {{ label | translate }}
        </span>
      </label>
    }
    <div class="flex align-items-center p-2 h-full">
      <p-inputSwitch inputId="{{ name }}"
        class="flex"
        ariaLabelledBy="{{ name }}_label"
        styleClass="{{ inputClass }} align-self-center"
        formControlName="{{ name }}"
        [disableControl]="disabled"
        [ngClass]="{
          'ng-invalid': control.invalid && control.touched,
          'ng-dirty': control.invalid && control.touched
        }"
        (onChange)="valueChange.emit($event)">
      </p-inputSwitch>
      @if (!labelTop && label) {
        <label
          id="{{ name }}_label"
          class="flex ml-2"
          for="{{ name }}">
          <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
            {{ label | translate }}
          </span>
        </label>
      }
    </div>
    @if (control.invalid && (control.dirty || control.touched)) {
      <br/>
      @for (err of control.errors | keyvalue; track err) {
        <small id="{{ name }}_help"
          class="p-error w-max">
          {{ err.value | translate }}
        </small>
        <br/>
      }
    }
  </div>
}
